import { HttpInterceptorFn } from '@angular/common/http';
import {inject} from '@angular/core';
import { MicroserviceService } from 'cs-shared-lib';

export const apiTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const microserviceService = inject(MicroserviceService);
  if(microserviceService.isInterceptableRequest(req.url) && microserviceService.isTokenExist()) {
    const token = microserviceService.getToken();
    req = req.clone({
      setHeaders: {
        'v5Token': `${token}`
      }
    });
  }
  return next(req);
};
